import React from 'react';
import { ReactComponent as File } from './logo.svg';
import { Link } from 'react-router-dom';
import PortalLogo from 'src/PlatformPortal/PortalLogo';

export default function Logo() {
  return (
    <Link to="/">
      <PortalLogo fallback={<File />} width={135} height={37} />
    </Link>
  );
}
